export const GET_ACCOUNT_SETTING_DATA = " GET_ACCOUNT_SETTING_DATA";
export const SET_ACCOUNT_SETTING_DATA = " SET_ACCOUNT_SETTING_DATA";
